import {
    fetchBasicJsonPostJson,
    fetchBasicJsonPost,
    fetchBasicUrlPostJson,
    fetchBasicUrlPost
} from '@/script/common';

export default {
    constant: {
        parentCode: (function () {
            var _locals = {
                employee: null,
                sender: null,
                representative: null
            };
            return {
                async employee() {
                    if (_locals.employee === null) {
                        await fetchBasicJsonPostJson(
                            '/Person/GetEmployeeParentCode'
                        ).then(resp => (_locals.employee = resp));
                    }
                    return _locals.employee;
                },
                async sender() {
                    if (_locals.sender === null) {
                        await fetchBasicJsonPostJson(
                            '/Person/GetSenderParentCode'
                        ).then(resp => (_locals.sender = resp));
                    }
                    return _locals.sender;
                },
                async representative() {
                    if (_locals.representative === null) {
                        await fetchBasicJsonPostJson(
                            '/Person/GetRepresentativeParentCode'
                        ).then(resp => (_locals.representative = resp));
                    }
                    return _locals.representative;
                }
            };
        })()
    },
    getData: (page, itemsPerPage, filter, signal, sort) => {
        var parameters = {
            page: page,
            pageSize: itemsPerPage
        };
        parameters.code =
            filter.code && /^\d+$/.test(filter.code) ? +filter.code : null;
        parameters.tabel =
            filter.tabel && /^\d+$/.test(filter.tabel) ? +filter.tabel : null;
        parameters.lastname = filter.lastname || null;
        parameters.firstname = filter.firstname || null;
        parameters.fathername = filter.fathername || null;
        parameters.personal_id =
            filter.personal_id && /^\d{11}$/.test(filter.personal_id)
                ? filter.personal_id
                : null;
        parameters.parent_code = filter.parent_code;
        parameters.parent_code_not = filter.parent_code_not;
        parameters.branch = filter.branch;
        parameters.only_active = filter.only_active;
        parameters.hr_module = filter.hr_module || false;
        parameters.kadr_department_code = filter.kadr_department_code;
        parameters.speciality_id = filter.speciality_id;
        parameters.position = filter.position;
        parameters.kadr_category = filter.kadr_category;
        if (sort && sort.sortBy) {
            parameters.sort_by = sort.sortBy;
            parameters.sort_desc = sort.sortDesc;
        }
        return fetchBasicJsonPostJson(
            '/Person/GetDataTableData',
            { data: parameters, signal: signal },
            { useBlock: !signal }
        );
    },
    add: item => fetchBasicJsonPost('/Person/Add', { data: item }),
    edit: item => fetchBasicJsonPost('/Person/Edit', { data: item }),
    openFileAttachment: personCode =>
        window.open(`/Person/FileAttachment?personCode=${personCode}`),
    getElFormData: () => fetchBasicJsonPostJson('/Person/GetElFormData'),
    openElForm: (personCode, id) =>
        window.open(`/Person/ElForm?personCode=${personCode}&elFormId=${id}`),

    getMissWorkDays: params =>
        fetchBasicJsonPostJson('/MissWorkDay/GetMissWorkDays', {
            data: params
        }),
    saveMissWorkDay: params =>
        fetchBasicJsonPost('/MissWorkDay/Save', {
            data: params
        }),
    setNames: item =>
        fetchBasicJsonPost('/Person/SetNames', {
            data: item
        }),
    getNames: item => fetchBasicJsonPostJson('/Person/GetNames', { data: item }),
    getPersonRepresentatives: personCode =>
        fetchBasicUrlPostJson('/Synonym/GetPersonRepresentatives', {
            data: { personCode }
        }),
    addPersonRepresentative: (personCode, representativeCode) =>
        fetchBasicUrlPost('/Synonym/AddPersonRepresentative', {
            data: { personCode, representativeCode }
        }),
    removePersonRepresentative: (personCode, representativeCode) =>
        fetchBasicUrlPost('/Synonym/RemovePersonRepresentative', {
            data: { personCode, representativeCode }
        }),
};
